module.exports = __webpack_public_path__ + "static/scale-model-of-chinatown-san-francisco-in-berkeley-california-44929154c0548be136a50c1ff2b5bb68.png";